var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('pb-icon',{staticClass:"fas fa-spinner fa-pulse fa-3x fa-fw"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }